/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  isAuthenticated: false,
  token: null,
  user: null,
  roles: [],
  entidad: null,
  refreshToken: null,
  periodoFiscalSelected: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    handleLogin: (state, { payload }) => {
      if (payload) {
        const {
          token,
          refreshToken,
          roles,
          permisos,
          periodo_fiscal: periodoFiscalSelected,
          entidad_municipal,
          entidad: _entidad,
          ...user
        } = payload;
        const entidad = _entidad || entidad_municipal;
        user.permisos = permisos;
        state.token = token;
        state.user = user;
        state.refreshToken = refreshToken;
        state.roles = roles;
        state.entidad = entidad;
        state.periodoFiscalSelected = periodoFiscalSelected;
        state.isAuthenticated = true;
      }
    },
    handleLogout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.roles = [];
      state.refreshToken = null;
      state.entidad = null;
      state.periodoFiscalSelected = null;
    },
    updateToken: (state, { payload }) => {
      state.token = payload;
    },
    updateUserInfo: (state, { payload }) => {
      state.user = { ...state.user, ...payload };
    },
    updateEntidadInfo: (state, { payload }) => {
      state.entidad = { ...state.entidad, ...payload };
    },
    updatePeriodoFiscalSelected: (state, { payload }) => {
      state.periodoFiscalSelected = payload;
    },
  },
});

export const {
  handleLogin,
  handleLogout,
  updateToken,
  updateUserInfo,
  updateEntidadInfo,
  updatePeriodoFiscalSelected,
} = authSlice.actions;

// Data Selectors
export const selectisAuthenticated = ({ auth }) => auth.isAuthenticated;
export const selectToken = ({ auth }) => auth.token;
export const selectUser = ({ auth }) => auth.user;
export const selectRoles = ({ auth }) => auth.roles;
export const seelectEntidad = ({ auth }) => auth.entidad || auth.entidad_municipal;
export const selectRefreshToken = ({ auth }) => auth.refreshToken;
export const selectPeriodoFiscalSelected = ({ auth }) => auth.periodoFiscalSelected;
export const selectLadaDefault = ({ auth }) => auth.entidad?.configuracion?.lada;
export const selectMoneda = ({ auth }) => auth.entidad?.configuracion?.moneda;

export default authSlice.reducer;
